import React, { Component } from "react";
import $ from "jquery";
import PDFObject from "pdfobject";

export default class Screen extends Component {
	constructor(props) {
		super(props);
		this.state = {
			filename: this.props.filename
		};
	}

	componentDidMount = () => {
		$(".bttn").on("click", function(e) {
			$("#view-box").empty();
			let name = $(e.target).attr("data-field");
			PDFObject.embed(`./pdf/${name}`, "#view-box");
		});
	};

	render() {
		return (
			<div id="view-box">
				<h4>Test Meeting</h4>
			</div>
		);
	}
}
